import {
  PromptButtons,
  PromptOption,
} from '@backrs_ui/grow-ui/src/pages/OfficeHours/molecules/PromptButtons';
import { useAppDispatch, useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import {
  getActiveLubavSession,
  createSessionAction,
} from '@backrs_ui/grow-ui/src/redux/lubavSessionState/lubavSessionState.utils';
import {
  setUserInput,
  setUserMessage,
} from '@backrs_ui/grow-ui/src/redux/solutionSession/solutionSession';
import { toggleMultiSelectOption } from '@backrs_ui/grow-ui/src/utils/multiSelectOptions';

type OptionSelectProps = Readonly<{
  variant:
    | {
        type: 'single_select';
        options: string[] | undefined;
        sendQAMessage: (message: string, LLMInput?: string) => void;
      }
    | {
        type: 'multi_select';
        options: string[] | undefined;
        sendQAMessage: (message: string, LLMInput?: string) => void;
        selectedOptions: string[];
        setSelectedOptions: (options: string[]) => void;
      };
}>;

export const OptionSelect = ({ variant }: OptionSelectProps) => {
  const dispatch = useAppDispatch();
  const activeSession = useAppSelector(getActiveLubavSession);

  if (!activeSession) {
    return null;
  }

  const handleSingleSelectClick = (option: string) => {
    if (variant.type !== 'single_select') return;

    variant.sendQAMessage(option, option);
    dispatch(createSessionAction(setUserMessage, activeSession)(''));
    dispatch(createSessionAction(setUserInput, activeSession)(undefined));
  };

  const handleMultiSelectClick = (option: string) => {
    if (variant.type !== 'multi_select') return;

    const updatedOptions = toggleMultiSelectOption(variant.selectedOptions, option);

    variant.setSelectedOptions(updatedOptions);
    const optionsString = updatedOptions.join(', ');

    dispatch(createSessionAction(setUserMessage, activeSession)(optionsString));
    dispatch(
      createSessionAction(
        setUserInput,
        activeSession,
      )({ type: 'SINGLE_INPUT', value: optionsString }),
    );
    dispatch(
      createSessionAction(
        setUserInput,
        activeSession,
      )({ type: 'MULTIPLE_INPUT', value: updatedOptions }),
    );
  };

  const promptOptions: PromptOption[] = (variant.options ?? []).map((option, i) => ({
    id: String(i),
    title: option,
  }));

  if (variant.type === 'single_select') {
    return (
      <PromptButtons
        onClick={(option) => handleSingleSelectClick(option.title)}
        isTyping={false}
        promptOptions={promptOptions}
        variant="SINGLE_SELECT"
      />
    );
  }

  const selectedOptionIds = variant.selectedOptions.map((selectedOption) => {
    const index = variant.options?.indexOf(selectedOption) ?? -1;

    return String(index);
  });

  return (
    <PromptButtons
      onClick={(option) => handleMultiSelectClick(option.title)}
      isTyping={false}
      promptOptions={promptOptions}
      selectedOptionIds={selectedOptionIds}
      variant="SINGLE_SELECT"
    />
  );
};
